import { notifications } from './notifications';

export default async function fetchWithTimeout<T>(
  callback: () => Promise<T>,
  timeout = 10000,
  onError?: () => void,
  retryOnError = true
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const timeoutPromise = new Promise<never>((resolve, reject) => {
    timeoutId = setTimeout(() => {
      notifications(
        'Кажется, что-то с интернетом. Проверьте соединение и попробуйте еще раз',
        'Произошла ошибка',
        3500
      );
      onError?.();
      reject(new Error('timeout'));
    }, timeout);
  });
  try {
    const result = await Promise.race([callback(), timeoutPromise]);
    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    console.log(error);
    if (!retryOnError) {
      throw error;
    }
    return await callback();
  }
}
